import { Button, Modal, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import errorIcon from '../../../assets/images/octagon-xmark.svg';
import LoadingApp from '../../../components/LoadingApp';
import ModalFeedBack from '../../../components/ModalFeedBack';
import { Beneficiario } from '../../../interfaces/entities/Beneficiario';
import { QuestionarioEmailCel } from '../../../interfaces/entities/QuestionarioEmailCel';
import { QuestionarioEmailCelOpcoes } from '../../../interfaces/entities/QuestionarioEmailCelOpcoes';
import { RegistrarBeneficiario } from '../../../interfaces/entities/RegistrarBeneficiario';
import { RegisterActionEnum } from '../../../interfaces/enum/RegisterActionEnum';
import { TokenRegisterType } from '../../../interfaces/enum/TokenRegisterType';
import RegisterLayout from '../../../layout/AuthLayout/RegisterLayout';
import { getQuestRecuperaLogin, getRegistroBeneficiario, postValidarquestionarioemailcel } from '../../../services/LoginService';
import { registerClient } from '../../../services/RegisterService';
import { sendTokenEmailRegistroBeneficiario, sendTokenSMSRegistroBeneficiario } from '../../../services/TokenService';
import { diferencaHorasMinutos } from '../../../utils/CalcDiffHours';
import AlertRegisterQuestions from './AlertRegisterQuestions';
import ConfirmationDataRegister from './ConfirmationDataRegister';
import OptionsTokenRegister from './OptionsTokenRegister';
import PasswordDefinition from './PasswordDefinition';
import RegisterForm from './RegisterForm';
import RegisterQuestions from './RegisterQuestions';
import TokenReceived from './TokenReceived';
import { sxButtonContained, sxTextButton, sxTypographySubTitle, sxTypographyTitle } from '../sxProps';
import { formatDateIso } from '../../../utils/DateFormat';


type Props = {}

const Register = (props: Props) => {
  const [RegisterAction, setRegisterAction] = useState<RegisterActionEnum>(RegisterActionEnum.RegisterForm);
  const [tokenRegisterType, setTokenRegisterType] = useState<TokenRegisterType>(TokenRegisterType.Email);
  const [questions, setQuestions] = useState<any>([]);
  const [modalFeedback, setmodalFeedback] = React.useState<null | { icon?: 'error' | 'success', title?: string, textButton?: string, subTitle?: string, action: () => void }>(null);
  const [beneficiario, setBeneficiario] = useState<Beneficiario>();
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [allowAlterData, setAllowAlterData] = useState<boolean>(false);
  const [registerToken, setRegisterToken] = useState<any>();
  const [dtNascimento, setDtNascimento] = useState<string>('');
  const [numCard, setNumCard] = useState<string>('');
  const [cpf, setCpf] = useState<string>('');
  const [openModalTimeQuestions, setOpenModalTimeQuestions] = useState<boolean>(false);
  const [hoursBlocked, setHoursBlocked] = useState<string>('');

  const navigate = useNavigate();

  const formBack = () => {
    switch (RegisterAction) {
      case RegisterActionEnum.RegisterOptions:
        setRegisterAction(RegisterActionEnum.ConfirmationData)
        break;
      case RegisterActionEnum.RegisterQuestions:
        setRegisterAction(RegisterActionEnum.AlertRegisterQuestions)
        break;
      case RegisterActionEnum.TokenReceived:
        setRegisterAction(RegisterActionEnum.RegisterOptions)
        break;
      case RegisterActionEnum.PasswordDefinition:
        setRegisterAction(RegisterActionEnum.RegisterOptions)
        break;
      case RegisterActionEnum.AlertRegisterQuestions:
        setRegisterAction(RegisterActionEnum.ConfirmationData)
        break;
      case RegisterActionEnum.ConfirmationData:
        setRegisterAction(RegisterActionEnum.RegisterForm)
        break;
    }
  };

  const openRegisterValidationData = async (dataNascimento: string, cpf: string, numeroCartao: string) => {
    setShowLoading(true);
    setDtNascimento(dataNascimento);
    setNumCard(numeroCartao);
    setCpf(cpf);
    await getRegistroBeneficiario(dataNascimento, cpf, numeroCartao).then(response => {

      const data: Beneficiario = response?.data[0];

      if (data.status !== "NCAD") {
        setmodalFeedback({
          icon: 'error',
          title: 'Ocorreu um erro',
          subTitle: 'Usuário já cadastrado, faça seu login',
          textButton: 'Acessar Canal',
          action: () => navigate('/')
        });
        setShowLoading(false);
        return;
      }

      if (data.email === "" && data.cel === "") {
        setmodalFeedback({
          icon: 'error',
          title: 'Atenção!',
          subTitle: 'Não conseguimos localizar seus dados de contato para finalizar o cadastro. Por favor, entre em contato conosco pelo 0800 013 66 88 para regularizar.',
          textButton: 'Fechar',
          action: () => setmodalFeedback(null)
        });
        setShowLoading(false);
        return;
      }

      setBeneficiario(data);
      setRegisterAction(RegisterActionEnum.ConfirmationData);
      setShowLoading(false);
    }).catch(error => {
      setmodalFeedback({
        icon: 'error',
        title: 'Ocorreu um erro',
        subTitle: error.response?.data?.mensagem ? error.response?.data?.mensagem : 'Erro ao verificar dados.',
        textButton: 'Fechar',
        action: () => setmodalFeedback(null)
      });
      setShowLoading(false);
    });
  };

  const openAlertRegisterQuestions = () => {
    setRegisterAction(RegisterActionEnum.AlertRegisterQuestions)
  };

 
  

  const openRegisterQuestions = async () => {
    if (beneficiario) {
      setShowLoading(true);

      var response = await getQuestRecuperaLogin(beneficiario.idUsrContr.toString()/* , beneficiario.login */);

      if (response?.status !== 200) {
        setHoursBlocked(diferencaHorasMinutos(new Date(), formatDateIso(response?.mensagem)));
        setOpenModalTimeQuestions(true);
        setShowLoading(false);
        return;
      }

      setQuestions(response?.data);
      setRegisterAction(RegisterActionEnum.RegisterQuestions);
    }
    setShowLoading(false);
  };

  const openRegisterTokenOptions = (email: string, celular: string) => {
    var benef = beneficiario;
    if (benef) {
      benef.cel = celular;
      benef.email = email;
    }
    setBeneficiario(benef);
    setRegisterAction(RegisterActionEnum.RegisterOptions);
  };

  const handleSelectTokenType = async (type: TokenRegisterType) => {
    setTokenRegisterType(type);
    setRegisterAction(RegisterActionEnum.TokenReceived);

    switch (type) {
      case TokenRegisterType.Email:
        const responseEmail = await sendTokenEmailRegistroBeneficiario({
          tipoToken: type.toString(),
          idUsrContr: beneficiario?.idUsrContr.toString(),
          nome: beneficiario?.nome,
          email: beneficiario?.email,
        });

        if (responseEmail?.status !== 200) {
          setmodalFeedback({
            icon: 'error',
            title: 'Ocorreu um erro',
            subTitle: 'Erro ao enviar e-mail',
            textButton: 'Fechar',
            action: () => setmodalFeedback(null)
          });
          return
        }
        setRegisterToken(responseEmail?.data);
        return
      case TokenRegisterType.SMS:
        const responseSMS = await sendTokenSMSRegistroBeneficiario({
          tipoToken: type.toString(),
          idUsrContr: beneficiario?.idUsrContr.toString(),
          cel: beneficiario?.cel,
        })

        if (responseSMS?.status !== 200) {
          setmodalFeedback({
            icon: 'error',
            title: 'Ocorreu um erro',
            subTitle: 'Erro ao enviar SMS',
            textButton: 'Fechar',
            action: () => setmodalFeedback(null)
          });
          return
        }
        setRegisterToken(responseSMS?.data);
        return
      default:
        return
    }
  };

  const openPasswordDefinition = () => {
    setRegisterAction(RegisterActionEnum.PasswordDefinition)
  }

  const allowChangeData = async (listAnswersOptions: Array<QuestionarioEmailCelOpcoes>) => {
    setShowLoading(true);

    var questionario: QuestionarioEmailCel = {
      listaOpcoes: listAnswersOptions,
      idUsrContr: beneficiario?.idUsrContr.toString() || ''
    }; 

    var response = await postValidarquestionarioemailcel(questionario);

    if (response?.status !== 200) {
      setmodalFeedback({
        icon: 'error',
        title: 'Dados inválidos',
        subTitle: 'Confira os dados preenchidos e tente novamente.',
        textButton: 'Fechar',
        action: () => setmodalFeedback(null)
      });
      setShowLoading(false);
      return
    }

    if (response.data.questionarioValid === "OK") {
      setAllowAlterData(true);
      setRegisterAction(RegisterActionEnum.ConfirmationData);

    } else {
      setHoursBlocked(diferencaHorasMinutos(new Date(), response?.data?.dtBloqueio));
      setOpenModalTimeQuestions(true);
    }
    setShowLoading(false);
  }

  const backToLogin = () => {
    navigate('/login')
  }

  const passwordRegister = async (password: string) => {
    setShowLoading(true)
    if (beneficiario) {
      const registrarBeneficiario: RegistrarBeneficiario = {
        cel: beneficiario.cel,
        cpf: cpf,
        dtNasc: dtNascimento,
        email: beneficiario.email,
        emailConf: beneficiario.email,
        numeroCartao: numCard,
        senha: password,
        senhaConfirmacao: password,
        tel: beneficiario.tel,
        tokenSMS: registerToken.numeroTokenUnimed
      }
      const response = await registerClient(registrarBeneficiario);

      if (response !== 'OK') {
        setmodalFeedback({
          icon: 'error',
          title: 'Ocorreu um erro',
          subTitle: 'Erro ao registrar beneficiário',
          textButton: 'Fechar',
          action: () => setmodalFeedback(null)
        });
        setShowLoading(false);
      } else {
        setmodalFeedback({
          icon: 'success',
          title: 'Senha definida com sucesso',
          subTitle: '',
          textButton: 'FAZER LOGIN',
          action: () => backToLogin()
        });
        setShowLoading(false);
      }
    }
    setShowLoading(false);
  }
  const { textStyleAccessibility, buttonStyleAccessibility, buttonTextStyleAccessibility } = useAccessibility();


  return (
    <RegisterLayout>
      <LoadingApp showLoading={showLoading} />
      {(() => {
        switch (RegisterAction) {
          case RegisterActionEnum.RegisterForm:
            return <RegisterForm
              openRegisterValidationData={openRegisterValidationData}
              backToLogin={backToLogin}
            />;

          case RegisterActionEnum.ConfirmationData:
            return <ConfirmationDataRegister
              formBack={formBack}
              beneficiario={beneficiario}
              allowAlterData={allowAlterData}
              openAlertRegisterQuestions={openAlertRegisterQuestions}
              openRegisterTokenOptions={openRegisterTokenOptions}
            />;

          case RegisterActionEnum.RegisterOptions:
            return <OptionsTokenRegister
              formBack={formBack}
              openTokenReceived={handleSelectTokenType}
              email={!!beneficiario?.email}
              cel={!!beneficiario?.cel}
            />;

          case RegisterActionEnum.TokenReceived:
            return <TokenReceived
              formBack={formBack}
              openPasswordDefinition={openPasswordDefinition}
              tokenRegisterType={tokenRegisterType}
              openTokenReceived={handleSelectTokenType}
              registerToken={registerToken}
            />;

          case RegisterActionEnum.AlertRegisterQuestions:
            return <AlertRegisterQuestions
              formBack={formBack}
              openRegisterQuestions={openRegisterQuestions}
            />;

          case RegisterActionEnum.RegisterQuestions:
            return <RegisterQuestions
              questions={questions}
              formBack={formBack}
              allowChangeData={allowChangeData}
            />;

          case RegisterActionEnum.PasswordDefinition:
            return <PasswordDefinition
              formBack={formBack}
              passwordRegister={passwordRegister}
            />;

        }
      })()}
      <ModalFeedBack
        showModal={modalFeedback ? true : false}
        icon={modalFeedback?.icon as 'success' | 'error'}
        textButton={modalFeedback?.textButton as string}
        title={modalFeedback?.title as string}
        subTitle={modalFeedback?.subTitle as string}
        handleShowModal={modalFeedback?.action}
        showButtonModal
        handleButtonModal={modalFeedback?.action}
        classNameModal='modal-feedback-mobile'
      />
      <Modal
        open={openModalTimeQuestions}
        onClose={() => backToLogin()}
      >
        <div style={textStyleAccessibility} className='container-modal' >
          <div>
            <img src={errorIcon} alt="Icone de erro." />
          </div>
          <div >
            <Typography sx={sxTypographyTitle}>{'Revalidação de dados'}</Typography>
            <p />
            <Typography sx={sxTypographySubTitle}>Uma ou mais perguntas foram respondidas de forma incorreta e, por isso, o cadastro{' '}<span style={{ fontWeight: 'bold', fontFamily: 'UnimedSans-bold' }}>ficará bloqueado por {hoursBlocked} horas.</span></Typography>
            <Typography sx={sxTypographySubTitle}>{'Após este período, você pode realizar uma nova tentativa.'}</Typography>
          </div>
          <div className='container-button'>
            <Button
              style={buttonStyleAccessibility}
              onClick={() => backToLogin()}
              sx={sxButtonContained}
              variant={"contained"}
            >
              <Typography style={buttonTextStyleAccessibility} sx={sxTextButton}>{'Voltar'}</Typography>
            </Button>
          </div>
        </div>
      </Modal>
    </RegisterLayout>
  )
}

export default Register